import script from "./tenant.vue?vue&type=script&setup=true&lang=js"
export * from "./tenant.vue?vue&type=script&setup=true&lang=js"

import "./tenant.vue?vue&type=style&index=0&id=215586ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-215586ce"]])

export default __exports__